import { render, staticRenderFns } from "./CopyTeModal.vue?vue&type=template&id=7cc779fd&scoped=true&"
import script from "./CopyTeModal.vue?vue&type=script&lang=js&"
export * from "./CopyTeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc779fd",
  null
  
)

export default component.exports